var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48225 1.86506C-1.50821e-07 3.34732 0 5.73296 0 10.5043V15.565C0 20.3363 -1.50821e-07 22.722 1.48225 24.2042C2.96451 25.6865 5.35015 25.6865 10.1215 25.6865H12.6518C17.4231 25.6865 19.8088 25.6865 21.291 24.2042C22.7733 22.722 22.7733 20.3363 22.7733 15.565V10.5043C22.7733 5.73296 22.7733 3.34732 21.291 1.86506C19.8088 0.382813 17.4231 0.382812 12.6518 0.382812H10.1215C5.35015 0.382812 2.96451 0.382813 1.48225 1.86506ZM5.37702 7.97391C5.37702 7.44985 5.80186 7.02502 6.32591 7.02502H16.4474C16.9714 7.02502 17.3963 7.44985 17.3963 7.97391C17.3963 8.49796 16.9714 8.92279 16.4474 8.92279H6.32591C5.80186 8.92279 5.37702 8.49796 5.37702 7.97391ZM5.37702 13.0346C5.37702 12.5106 5.80186 12.0857 6.32591 12.0857H16.4474C16.9714 12.0857 17.3963 12.5106 17.3963 13.0346C17.3963 13.5587 16.9714 13.9835 16.4474 13.9835H6.32591C5.80186 13.9835 5.37702 13.5587 5.37702 13.0346ZM6.32591 17.1465C5.80186 17.1465 5.37702 17.5713 5.37702 18.0954C5.37702 18.6194 5.80186 19.0442 6.32591 19.0442H12.6518C13.1759 19.0442 13.6007 18.6194 13.6007 18.0954C13.6007 17.5713 13.1759 17.1465 12.6518 17.1465H6.32591Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5005 19.6171C24.5005 23.7593 21.1425 27.1173 17.0002 27.1173C12.858 27.1173 9.5 23.7593 9.5 19.6171C9.5 15.4748 12.858 12.1168 17.0002 12.1168C21.1425 12.1168 24.5005 15.4748 24.5005 19.6171Z",
    fill: "white",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21.7659L20.5197 23.7408",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4794 21.7656C18.3385 21.7656 19.8455 20.292 19.8455 18.4741C19.8455 16.6563 18.3385 15.1826 16.4794 15.1826C14.6203 15.1826 13.1133 16.6563 13.1133 18.4741C13.1133 20.292 14.6203 21.7656 16.4794 21.7656Z",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.4210230ff14d81d6f1ea8400ed5eca55.svg";
export { ForwardRef as ReactComponent };